import { __ } from '@wordpress/i18n'
import { Fragment } from '@wordpress/element'
import { registerPlugin } from '@wordpress/plugins'
import {
	PluginPostStatusInfo,
	PluginSidebarMoreMenuItem,
	PluginSidebar
} from '@wordpress/edit-post'
import { i18n } from 'cartzillagb'
import { CartzillaGBIconTextured } from '~cartzillagb/icons'

import PostAdditionalMeta from './meta-fields/post'
import PagePluginSidebar from './meta-fields/page'

const PluginCustomMetaFields = () => {
	return(
		<Fragment>
			<PluginPostStatusInfo>
				<div className="cartzillagb-meta-fields" style={ { width: '100%' } }>
					<PostAdditionalMeta />
				</div>
			</PluginPostStatusInfo>
			<PluginSidebarMoreMenuItem
				target="cartzilla-options-sidebar"
				icon={ CartzillaGBIconTextured }
			>
				{ __( 'Cartzilla Options', i18n ) }
			</PluginSidebarMoreMenuItem>
			<PluginSidebar name="cartzilla-options-sidebar" title={ __( 'Cartzilla Options', i18n ) }>
				<PagePluginSidebar />
			</PluginSidebar>
		</Fragment>
	)

}

registerPlugin( 'czgb-sidebar', {
	icon: CartzillaGBIconTextured,
	render: PluginCustomMetaFields
})
